// src/pages/auth/Login.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import AuthLayout from '../../components/AuthLayout';
import MessageBox from '../../components/MessageBox';
import api from '../../api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);

    try {
      const data = await api.login({ email, password });

      if (data?.token?.token) {
        localStorage.setItem('token', data.token.token);

        setMessage({
          type: 'success',
          text: 'Logged in successfully.',
        });

        setTimeout(() => {
          navigate('/dashboard');
        }, 1000);
      } else {
        setMessage({
          type: 'error',
          text: 'Login failed: No token received.',
        });
      }
    } catch (error) {
      console.error('Login error:', error);

      setMessage({
        type: 'error',
        text: error.message || 'Login failed. Please try again.',
      });
    }
  };

  return (
    <AuthLayout>
      <div style={styles.header}>
        <div style={styles.logoWrap}>
          <img src="/yabatho-logo.png" alt="YaBatho Logo" style={styles.logo} />
        </div>

        <p style={styles.kicker}>YaBatho Admin</p>

        <h2 style={styles.title}>Admin Login</h2>

        <p style={styles.subtitle}>Sign in to manage the YaBatho platform.</p>
      </div>

      {message && (
        <MessageBox
          type={message.type}
          message={message.text}
          onClose={() => setMessage(null)}
        />
      )}

      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="email"
          placeholder="Admin Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          required
        />

        <button style={styles.button} type="submit">
          Login
        </button>
      </form>

      <div style={styles.footer}>
        <Link to="/forgot-password" style={styles.link}>
          Forgot Password?
        </Link>
      </div>
    </AuthLayout>
  );
}

const styles = {
  header: {
    textAlign: 'center',
    marginBottom: 28,
  },

  logoWrap: {
    width: 220,
    height: 86,
    borderRadius: 8,
    backgroundColor: '#FFFDF7',
    border: '1px solid #E6D8BE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
  },

  logo: {
    width: 190,
    height: 72,
    objectFit: 'contain',
  },

  kicker: {
    margin: '0 0 6px',
    color: '#C9A14A',
    fontSize: 12,
    fontWeight: 900,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },

  title: {
    fontSize: 28,
    fontWeight: 900,
    color: '#0F3D2E',
    margin: '0 0 8px',
  },

  subtitle: {
    margin: 0,
    fontSize: 14,
    color: '#6E6254',
    lineHeight: 1.6,
  },

  form: {
    width: '100%',
  },

  input: {
    width: '100%',
    padding: 13,
    marginBottom: 15,
    border: '1px solid #E6D8BE',
    borderRadius: 12,
    fontSize: 15,
    color: '#0F3D2E',
    backgroundColor: '#FFFDF7',
    outline: 'none',
    boxSizing: 'border-box',
  },

  button: {
    width: '100%',
    padding: 13,
    backgroundColor: '#C9A14A',
    color: '#0F3D2E',
    border: 'none',
    borderRadius: 12,
    cursor: 'pointer',
    fontWeight: 900,
    fontSize: 15,
    marginTop: 8,
  },

  footer: {
    marginTop: 20,
    textAlign: 'center',
    fontSize: 14,
  },

  link: {
    color: '#0F3D2E',
    textDecoration: 'none',
    fontWeight: 800,
  },
};
